var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMrMauritania(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_20856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "#CD2A3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 6.75H0V38.25H60V6.75Z",
    fill: "#006233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 14.4937C15.9375 18.2233 17.4191 21.8001 20.0563 24.4373C22.6935 27.0746 26.2704 28.5562 30 28.5562C33.7296 28.5562 37.3065 27.0746 39.9437 24.4373C42.5809 21.8001 44.0625 18.2233 44.0625 14.4937C44.375 15.6936 44.5325 16.9287 44.5312 18.1687C44.5312 22.0226 43.0003 25.7187 40.2751 28.4438C37.55 31.1689 33.8539 32.6999 30 32.6999C26.1461 32.6999 22.45 31.1689 19.7248 28.4438C16.9997 25.7187 15.4687 22.0226 15.4687 18.1687C15.4669 16.9286 15.6245 15.6935 15.9375 14.4937Z",
    fill: "#FFC400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 8.79395L31.2656 12.6846H35.3438L32.0344 15.0846L33.3 18.9658L29.9906 16.5658L26.6813 18.9658L27.9469 15.0846L24.6375 12.6846H28.725L30 8.79395Z",
    fill: "#FFC400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_20856"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMrMauritania);
export default __webpack_public_path__ + "static/media/mr Mauritania.804149d1559dc7121191b9f59a3a7f42.svg";
export { ForwardRef as ReactComponent };